<template>
  <v-button
    class="workout-form-capture"
    ghost
    icon
    @click.stop="$emit('capture', firstEmptyIndex)"
  >
    <template v-if="iconStyle">
      <v-icon :class="`--color-${iconStyle.color}`" :icon="iconStyle.icon" />
    </template>
    <template v-else>
      <svg
        class="workout-form-capture__progress"
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <circle cx="50" cy="50" r="40" fill="none" stroke-width="15" />
        <circle
          cx="50"
          cy="50"
          r="40"
          fill="none"
          stroke-width="15"
          stroke-dasharray="100"
          :stroke-dashoffset="100 - percent"
          pathLength="100"
        />
      </svg>
    </template>
  </v-button>
</template>

<script>
import { CAPTURE_STATUS } from "@/lib/form-utils"
import { mapGetters } from "vuex"

const EMPTY = "empty"

export default {
  props: {
    captureUid: { type: String, required: true }
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters("forms", [
      "capturePercentByUid",
      "captureStatusesByUid",
      "firstCaptureEmptyIndex"
    ]),

    statuses() {
      return this.captureStatusesByUid(this.captureUid) || []
    },

    firstEmptyIndex() {
      return this.firstCaptureEmptyIndex(this.captureUid)
    },

    percent() {
      if (this.statuses.length === 0) return 0
      return (
        (this.statuses.filter(s => !!s).length / this.statuses.length) * 100
      )
    },

    currentStatus() {
      if (this.percent === 100) {
        if (this.statuses.every(s => s === CAPTURE_STATUS.SAVED)) {
          return CAPTURE_STATUS.SAVED
        } else {
          return CAPTURE_STATUS.MISSED
        }
      } else if (this.percent === 0) {
        return EMPTY
      } else {
        return null
      }
    },

    iconStyle() {
      switch (this.currentStatus) {
        case CAPTURE_STATUS.SAVED:
          return { icon: "check_circle", color: "green" }
        case CAPTURE_STATUS.MISSED:
          return { icon: "remove_circle", color: "red" }
        case EMPTY:
          return { icon: "add_circle", color: "grey" }
        default:
          return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.workout-form-capture {
  padding: 1px;
  font-size: $size--6;

  .v-icon {
    &.--color-grey {
      color: $color-ui--grey-40;
    }

    &.--color-red {
      color: $color-ui--red;
    }

    &.--color-green {
      color: $color-ui--green;
    }
  }
}

.workout-form-capture__progress {
  width: 30px;
  height: 30px;
  transform: rotate(-90deg);

  circle {
    &:first-child {
      stroke: $color-ui--grey-20;
    }

    &:last-child {
      stroke: $color-ui--green;
    }
  }
}
</style>
